import { render, staticRenderFns } from "./GModal.vue?vue&type=template&id=45eeb91c&scoped=true"
import script from "./GModal.vue?vue&type=script&lang=js"
export * from "./GModal.vue?vue&type=script&lang=js"
import style0 from "./GModal.vue?vue&type=style&index=0&id=45eeb91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eeb91c",
  null
  
)

export default component.exports